<div class="flex flex-col py-2" [ngClass]="{ 'px-6 py-5': !parameterization }">
  <form [formGroup]="sportForm">
    <div
      *ngIf="!parameterization"
      class="flex mx-2 items-center justify-between mb-6"
    >
      <!--
        Aqui eu traria ao inves da palavra esporte o nome do esporte,
        como se trata da ediçao de um esporte faz sentido deixa-lo mais
        em evidencia
        <p class="text-2xl font-bold text-sigecom-dark-gray">{{selectedSport?.espTxDescricao ?? 'Esporte'}}</p>

      -->
      <p class="text-2xl font-bold text-sigecom-dark-gray">Esporte</p>
    </div>

    <div
      class="bg-white rounded-lg"
      [ngClass]="{ 'shadow-lg p-4 px-5': !parameterization }"
    >
      <div class="grid grid-cols-4">
        <sigecom-input-container
          *ngIf="!parameterization"
          class="col-span-full mb-2"
          label="Nome do esporte"
          disabled
        >
          <input
            sigecom-input
            type="text"
            [value]="selectedSport?.espTxDescricao"
            [disabled]="true"
          />
        </sigecom-input-container>
        <div class="col-span-4">
          <div class="flex justify-between items-center mb-3 pt-2 pb-2">
            <p
              class="text-2xl pl-2 text-sigecom-dark-gray"
              [ngClass]="{ 'font-semibold text-lg': parameterization }"
            >
              Modelo esportivo
            </p>
            <div
              *ngIf="parameterization"
              class="flex items-center gap-4 rounded-md bg-gray-200 px-3 py-1 border-gray-300 border"
              [ngClass]="{
                'bg-blue-200/50': sportForm.get('ettBlPadrao')!.value!,
                'opacity-50 pointer-events-none':
                  desibledButtonDefaultTemplate || !petBlEdicaoBloqueada,
              }"
            >
              <h1 class="text-sm text-gray-700">Template padrão</h1>
              <sigecom-switch
                [switchState]="sportForm.get('ettBlPadrao')!.value!"
                (switchStateChange)="onToggleDefaultTemplate($event)"
              />
            </div>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <sigecom-input-container label="Nomenclatura do período">
              <input
                sigecom-input
                type="text"
                placeholder="Ex: Set 1"
                formControlName="ettTxNomePeriodo"
              />
            </sigecom-input-container>

            <sigecom-input-container label="Quantidade de períodos">
              <input
                sigecom-input
                type="number"
                placeholder="Ex: 0"
                formControlName="ettNrQtdPeriodo"
              />
            </sigecom-input-container>

            <sigecom-new-dropdown
              formControlName="ettTxTipoPlacar"
              [options]="scoreTypeOptions"
              label="Tipo de placar"
              [optionLabel]="'label'"
              [optionIdentify]="'value'"
              placeholder="Selecione o formato da etapa"
              formControlName="ettTxTipoPlacar"
            />

            <sigecom-new-dropdown
              formControlName="ettTxCriterioVitoriaPlacar"
              [options]="victoryCriteriaOptions"
              label="Critério de vitória"
              [optionLabel]="'label'"
              [optionIdentify]="'value'"
              placeholder="Selecione o critério de vitória da etapa"
            />
          </div>
        </div>
        <div class="col-span-4">
          <p class="text-xl pl-2 py-1 text-sigecom-dark-gray block mt-3 mb-3">
            Pontuação
          </p>
          <div class="grid grid-cols-3 gap-3 mb-3">
            <sigecom-input-container label="Pontos por vitória">
              <input
                sigecom-input
                type="number"
                placeholder="Ex: 3"
                formControlName="ettNrPontosVitoria"
              />
            </sigecom-input-container>

            <sigecom-input-container label="Pontos por derrota">
              <input
                sigecom-input
                type="number"
                placeholder="Ex: 0"
                formControlName="ettNrPontosDerrota"
              />
            </sigecom-input-container>

            <sigecom-input-container label="Pontos por empate">
              <input
                sigecom-input
                type="number"
                placeholder="Ex: 0"
                formControlName="ettNrPontosEmpate"
              />
            </sigecom-input-container>
            <div class="grid grid-cols-2 gap-3 col-span-3">
              <sigecom-input-container label="Pontos por vitória W.O">
                <input
                  sigecom-input
                  type="number"
                  formControlName="ettNrPontosVitoriaWo"
                  placeholder="Ex: 0"
                />
              </sigecom-input-container>

              <sigecom-input-container label="Pontos por derrota W.O">
                <input
                  sigecom-input
                  type="number"
                  placeholder="Ex: 0"
                  formControlName="ettNrPontosDerrotaWo"
                />
              </sigecom-input-container>
            </div>
          </div>
        </div>
        <div class="col-span-full">
          <p class="text-xl pl-2 text-sigecom-dark-gray mb-3 mt-3">
            Placar do w.o
          </p>
          <sigecom-set-scoreboard
            [(sets)]="placaresWo"
            (setsChange)="placaresWo = $event"
            (setsRemoved)="onWoSetsRemoved($event)"
          />
        </div>
        <div class="col-span-4">
          <p class="text-xl pl-2 py-3 text-sigecom-dark-gray mb-3 mt-3">
            Critérios de desempate
          </p>
          <sigecom-radio-toggle
            label="Tipo de desempate"
            [required]="true"
            [options]="criteriaModalityOptions"
            [labelKey]="'label'"
            [valueKey]="'value'"
            [(selected)]="tipoDesempateSelecionado"
          />

          <div class="flex justify-center gap-2">
            <app-item-selector
              class="w-3/4 mt-3"
              [items]="tieBreakCriteriaList"
              [showInscriptionLine]="false"
              [label]="'Selecione os critérios de desempate:'"
              [placeholder]="'Buscar critério'"
              (search)="filterCriteria($event)"
              (add)="addTieBreakCriteria($event)"
            >
            </app-item-selector>

            <sigecom-item-selected-list
              emptyListMessage="Selecione ao menos um critério de desempate"
              messageIsAlert
              class="w-full mt-3"
              [selectedItems]="selectedTieBreakCriteria"
              [showInscriptionLine]="false"
              [qtdMaxItems]="tieBreakCriteriaList.length"
              [label]="'Critérios selecionados:'"
              [showSwitch]="false"
              (remove)="removeTieBreakCriteria($event)"
              [dragEnabled]="true"
            >
              <ng-template #customIcons let-item>
                <sigecom-menu-bar-item
                  icon="sort"
                  color="cbde-dark-blue"
                  title="Arraste para reordenar"
                />
              </ng-template>
            </sigecom-item-selected-list>
          </div>
        </div>
      </div>
      <div class="w-full flex justify-end pt-4">
        <sigecom-button
          type="info"
          title="Salvar modelo esportivo"
          icon="check"
          [outlined]="true"
          class="rounded-lg"
          (buttonClicked)="onSubmit()"
          [disabled]="
            !!sportForm.invalid ||
            !!woForm.invalid ||
            !petBlEdicaoBloqueada ||
            selectedTieBreakCriteria.length <= 0
          "
          *ngIf="parameterization"
        >
        </sigecom-button>
      </div>
    </div>

    <sigecom-action-buttons
      *ngIf="!parameterization"
      (cancelClick)="navigateToSportParameterizationList()"
      (saveClick)="onSubmit()"
      [isSaveDisabled]="
        !!sportForm.invalid ||
        !!woForm.invalid ||
        selectedTieBreakCriteria.length <= 0
      "
    >
    </sigecom-action-buttons>
  </form>
</div>
